import React, { CSSProperties } from "react";

interface EllipsisProps {
  lines?: number;
  maxChars?: number;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const Ellipsis = ({ lines = 1, maxChars = 40, style, children }: EllipsisProps) => {
  const ellipsisStyle: CSSProperties =
    lines === 1
      ? {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }
      : {
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: lines,
        };

  const content =
    maxChars && typeof children === "string" && children.length > maxChars
      ? children.slice(0, maxChars) + "…"
      : children;

  const fullText = typeof children === "string" ? children : undefined;

  return (
    <div style={{ ...ellipsisStyle, ...style }} title={fullText}>
      {content}
    </div>
  );
};

export default Ellipsis;
